import { render, staticRenderFns } from "./UrunListesi.vue?vue&type=template&id=10dc878f&scoped=true&"
import script from "./UrunListesi.vue?vue&type=script&lang=js&"
export * from "./UrunListesi.vue?vue&type=script&lang=js&"
import style0 from "./UrunListesi.vue?vue&type=style&index=0&id=10dc878f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10dc878f",
  null
  
)

export default component.exports